<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.Name"
                :label="$t('sysUser.name', locale)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <color-picker-primary-secondary
                style="width: 100px;"
                :primaryColor="editedItem.PrimaryColor"
                :secondaryColor="editedItem.SecondaryColor"
                :onChangeColor="handleChangeColors"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-switch
                v-model="editedItem.External"
                :label="$t('workspace.external', locale)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <select-sys-users
                area="queue"
                :workspaceID="editedItem.ID"
                :onChangeUser="handleChangeUser"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <action-buttons
        :id="editedItem.ID"
        :onDeleteItem="handleDeleteItem"
        :onSaveItem="handleSave"
        :onClose="handleClose"
        :locale="locale"
      />
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '@/services/api'
  import SelectSysUsers from '@/components/SelectSysUsers'
  import ActionButtons from '@/components/ActionButtons'
  import ColorPickerPrimarySecondary from '@/components/ColorPickerPrimarySecondary'

  export default {
    components: {
      ActionButtons,
      SelectSysUsers,
      ColorPickerPrimarySecondary,
    },
    props: {
      editID: {
        type: String,
        required: false,
        default: null
      },
      dialog: {
        type: Boolean,
        required: false,
        default: false
      },
      onGetData: {
        type: Function,
        required: true
      },
      onCloseDialog: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      formTitle: '',
      defaultItem: {
        Name: '',
        Users: [],
        External: false,
        PrimaryColor: null,
        SecondaryColor: null,
      },
      editedItem: {}
    }),
    computed: {
      ...mapState('app',['locale']),
    },
    watch: {
      dialog (v) {
        if (v) 
          if (this.editID) this.handleGetItem (this.editID)
          else this.editedItem = this.defaultItem
      }
    },
    methods: {
      handleGetItem(v) {
        api.getItem ('queue', 'private/workspaces/', v)
        .then(response => {   
          this.editedItem = response
        })
      },
      handleChangeUser (v) {
        this.editedItem.Users = v
      },
      handleChangeColors (primaryColor, secondaryColor) {
        this.editedItem.PrimaryColor = primaryColor ? primaryColor : null
        this.editedItem.SecondaryColor = secondaryColor ? secondaryColor : null
      },
      handleClose () {
        this.onCloseDialog()
      },
      handleDeleteItem (v) {
        if (v) 
          api.deleteItem ('queue', 'private/workspaces/', v)
          .then(() => {                      
            this.onGetData()
            this.onCloseDialog()
          })
      },
      handleSave () {
        if (!this.editedItem.RenameFolders || this.editedItem.RenameFolders.length === 0) this.editedItem.RenameFolders = null
        if (this.editedItem.ID)
          api.updateItem ('queue', 'private/workspaces/', this.editedItem.ID, this.editedItem)
          .then(() => {          
            this.onGetData()
            this.onCloseDialog()
          })  
        else
          api.addItem ('queue', 'private/workspaces/', this.editedItem)
          .then(() => {          
            this.onGetData()
            this.onCloseDialog()
          })        
      }
    },
  }
</script>
